module.exports = __webpack_public_path__ + "static/media/Ehud Olmert .27a0637b.docx";